import { CheckListFilter } from '@app/modules/table/classes/column-filters/check-list/check-list-filter.class';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { JobPosting } from '@models/recruiting/job-posting.model';

export class StatusColumn extends Column {
    title = 'applicant-tracker.status';
    property = 'archivedAt';
    sortable = true;
    type: CellDisplay = CellDisplay.string;

    activeStatusLabel = 'applicant-tracker.active';
    archivedStatusLabel = 'applicant-tracker.archived';
    pausedStatusLabel = 'applicant-tracker.paused';
    draftStatusLabel = 'applicant-tracker.draft';

    constructor() {
        super();

        const defaultFilters = [
            { label: this.activeStatusLabel, value: 'active', initiallyActive: true },
            { label: this.archivedStatusLabel, value: 'archived' },
            { label: this.pausedStatusLabel, value: 'paused' },
        ];

        this.filter = new CheckListFilter('status', [
            ...defaultFilters,
            { label: this.draftStatusLabel, value: 'draft', initiallyActive: true },
        ]);
    }

    getDisplayPropertyValue(jobPosting: JobPosting): string {
        if (jobPosting.isArchived) {
            return this.archivedStatusLabel;
        }

        if (jobPosting.isPaused) {
            return this.pausedStatusLabel;
        }

        if (jobPosting.isDraft) {
            return this.draftStatusLabel;
        }

        return this.activeStatusLabel;
    }
}
